import styled, { css } from 'styled-components'
import { theme } from '../../styles'

const corTexto = ( valor ) => css`
  color: ${valor};

  &:visited,
  &:active {
    color: ${valor};
  }
`

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  text-align: center;
  text-decoration: none;
  transition: transform 0.14s ease, box-shadow 0.14s ease, background 0.14s ease;

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`

export const BtnPrimary = styled.button`
  ${base}
  background: ${theme.cores.navy};
  ${corTexto( theme.cores.white )}
  box-shadow: 0 4px 14px rgba(38, 42, 95, 0.26);

  &:hover:not(:disabled) {
    background: ${theme.cores.navy700};
  }
`

export const BtnOrange = styled.button`
  ${base}
  background: ${theme.cores.accent};
  ${corTexto( theme.cores.white )}
  box-shadow: 0 4px 14px rgba(213, 112, 27, 0.34);

  &:hover:not(:disabled) {
    background: #C56415;
  }
`

export const BtnGhost = styled.button`
  ${base}
  background: ${theme.cores.paperAlt};
  ${corTexto( theme.cores.inkDeep )}
  border-color: ${theme.cores.line};

  &:hover:not(:disabled) {
    background: ${theme.cores.paper};
  }
`

export const BtnDanger = styled.button`
  ${base}
  background: ${theme.cores.statusStop};
  ${corTexto( theme.cores.white )}

  &:hover:not(:disabled) {
    background: #9C2F29;
  }
`
